<template>
  <div id="app">
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import GlobalEventBus from './helpers/EventBus.js'
import EventBus from './helpers/EventBus.js'
export default {
  name: 'App',
  data () {
    return {
      title: null,
      paginaActual:null,
    }
  },
  methods: {
    casilla() {
      this.$router.push('/casilla-electronica')
    },
    editarUsuario() {
      this.$router.push('/editarUsuario')
    },

 
    },
  watch: {
    '$route' (to, from) {
      this.title = to.meta.breadCrumb
      this.paginaActual = to.name
    }
  }
  
};
</script>

<style>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}


.header img {
    padding-top: 8px;
    padding-bottom: 10px;
}
/* .header {
    background: #06c;
} */
 .footer {
    /* position: absolute;
    bottom: 0; */
    width: 100%;
    background: #06c;
} 
.footer .texto {
    text-align: center;
    padding: 13px 0;
    color: #fff;
}
@media only screen and (max-width: 600px) {
  .breadcrumb {
    padding-left: 0px;
    padding-right: 0px;
  }
  .content-btn {
    background: #bed730;
  }
  header {
    border-bottom: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue